import React, { useEffect, useState } from "react";
import Collapsible from "react-collapsible";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import Catalogus from "../../components/catalogus/Catalogus";
import {
  farmerProducts,
  getAllSupplierInfo,
} from "../../services/assortiment/actions";
import "./infoScreen.scss";

function SuppliersInfo(props) {
  let supId = null;
  const location = useLocation();
  if (location.state) {
    const { from } = location.state;
    supId = from;
  }

  const [allSupplierInfo, setAllSupplierInfo] = useState(null);
  const [currentSupplier, setCurrentSupplier] = useState([]);
  const [products, setProducts] = useState(null);

  const getCurrentSupplier = (id) => {
    if (allSupplierInfo) {
      const temp = allSupplierInfo.filter((row) => row.id == id);
      if (temp.length > 0) {
        setCurrentSupplier(temp[0]);
      }
    }
  };

  useEffect(() => {
    getAllSupplierInfo(
      props.loginSuccesful,
      props.identifyInfo,
      setAllSupplierInfo
    );
  }, []);

  useEffect(() => {
    if (supId) {
      getCurrentSupplier(supId);
      farmerProducts(
        props.identifyInfo,
        supId,
        props.loginSuccesful,
        setProducts
      );
    }
  }, [allSupplierInfo, supId]);

  const assortimentColumnsTable = [
    { name: "Naam", dataName: "name" },
    { name: "Prijs", dataName: "salesprice" },
  ];

  return currentSupplier.name ? (
    <div>
      <h4>{currentSupplier.name}</h4>
      {currentSupplier.photo ? (
        <img className="supplierPhoto" src={currentSupplier.photo}></img>
      ) : null}
      <div style={{ marginTop: "10px" }}>
        <Collapsible
          trigger="Klik voor het verhaal van de boer..."
          className="supplierText"
        >
          <div dangerouslySetInnerHTML={{ __html: currentSupplier.content }} />
        </Collapsible>
      </div>
      {products ? (
        <Catalogus
          data={products}
          columnsMapping={assortimentColumnsTable}
          publicAssortiment={true}
        />
      ) : null}
    </div>
  ) : (
    <p1>
      Er is momenteel geen informatie beschikbaar over deze boer! Kies een
      andere boer.
    </p1>
  );
}

function mapStateToProps(state) {
  return {
    identifyInfo: state.identify.identifyInfo,
    loginSuccesful: state.login.data.loginSuccesful,
  };
}

export default connect(mapStateToProps)(SuppliersInfo);
